import { OnResizeService } from '@services/on-resize.service';
import { ConfigService } from './../../services/webFeeder/config.service';
import { Constants } from '@utils/constants';
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SimpleOrder } from '@model/simpleOrder';
import { MatDialog } from '@angular/material/dialog';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { AbstractItem } from '@business/base/abstract-item';
import { AppUtils } from '@utils/app.utils';
import { Subscription, of } from 'rxjs';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { MarketEnum } from '@model/enum/market.enum';
import { DatePipe } from '@angular/common';
import { BovBmfModel } from '@dto/custody-model-bov-bmf';
import { PositionService } from '@services/webFeeder/sckt-position.service';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { StatusConnection } from '@model/status-connection';
import { NotificationsService } from 'angular2-notifications';
import { AuthServer } from '@services/auth-server.service';
import { SideEnum } from '@model/enum/side.enum';
import { OrderEstrategyTypeEnum } from '@model/enum/order-estrategy-type.enum';
import { TimeInForceEnum } from '@model/enum/time-in-force.enum';
import { BilletInputConfigModel } from '@model/billet-input-config.model';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { ConfigCardsModel } from '@model/config-comp-settings.model';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { MarketTypeEnum } from '@model/enum/market-type.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: Constants.WINDOW_NAME_BILLET_ROOT,
  templateUrl: './billet-root.component.html',
})
export class BilletRootComponent extends AbstractItem implements OnInit, OnDestroy {
  @Input() data: any;
  dialog: MatDialog;
  model: SimpleOrder = new SimpleOrder();
  typeOrderSelected: BilletInputConfigModel = new BilletInputConfigModel();
  valueInitBookStaircase: any = [];
  oldAccount: any;
  loading = true;
  componentName = Constants.TITLE_CARD_BILLET_ROOT;
  tooltipRemoveFromWks = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  toolTipEngine = Constants.TOOLTIP_ENGINE;
  toolTipCenterStaircaseON = Constants.TOOLTIP_CENTER_STAIRCASE_ON;
  toolTipCenterStaircaseOFF = Constants.TOOLTIP_CENTER_STAIRCASE_OFF;
  whiteLabel = this._configService.getConfigWhitelabel();
  listBillet = Constants.BILLET_TYPE_BILLET;
  billetSelected: any;
  typeOrderOptions = Constants.BILLET_TYPE_ORDER;
  strategiesList = [];
  orderStrategy: any;
  loadingStrategies: boolean;
  isUpdateOnDemand: boolean;
  newWindow: boolean;
  private _subscriptionQuote: Subscription;
  private _subscriptionAuthHbLogged: Subscription;
  messageQuote = new MessageQuote();
  oldSymbolTemp: string;
  initialPrice: boolean;
  hiddenInvalid: boolean;
  company = '';
  tickSize = 2;
  lastTrade: any;
  price: any;
  showVariation: boolean;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  variation: any;
  coinVariation: any;
  isLoggedNegotiation: boolean;
  private subscriptionStatusOms: Subscription;
  statusOmsOnline: boolean;
  msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  private subscriptionPositionList: Array<Subscription> = [];
  listPosition: BovBmfModel = new BovBmfModel();
  intervalAccount: any;
  isSubscribeBook: boolean;
  showConfirmationBillet: boolean;
  hiddenConfirmationBillet: boolean;
  hiddenHeaderFull: boolean;
  loadingImgName: boolean;
  subscribeScktDailyorder: boolean;
  averagePricePos: any;
  subscriptionSendOrder: Subscription;
  financialAccount: any = {};

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _quoteService: QuoteService,
    private _configService: ConfigService,
    private _datePipe: DatePipe,
    private _positionService: PositionService,
    private _statusOmsService: StatusOmsService,
    private _notificationService: NotificationsService,
    private cdRef: ChangeDetectorRef,
    private _authServer: AuthServer,
    private _onResizeService: OnResizeService,
    private _dailyOrderService: DailyOrderService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.dialog = _dialog;
    this.typeOrderSelected = this.typeOrderOptions[0];
    this.subscriptionOms();
    this.setInitValueBillet();
    this._configService.changeAccountBillet$.subscribe((res) => {
      if (res) {
        this.changeAccount(res);
      }
    });
    this.subscriptionSendOrder = this._dailyOrderService.showHiddenPadOrderConfirmation$.subscribe((res) => {
      if (res) {
        this.resetOrderAfterSend();
      }
    });
  }

  ngOnInit() {
    let indexTemp = 0;
    const configCookieBillet = this._configService.getCookieConfigCards(this.getBilletKey());
    if (this.data && this.data.data && this.data.data.filter) {
      indexTemp = this.listBillet.findIndex((x) => x.name === this.data.data.filter);
    } else if (configCookieBillet && configCookieBillet.billetRootTypeId >= 0) {
      indexTemp = configCookieBillet.billetRootTypeId;
    }
    this.billetSelected = indexTemp >= 0 ? this.listBillet[indexTemp] : this.listBillet[0];
    this.hiddenConfirmationBillet = configCookieBillet && configCookieBillet.billetRootHiddenConfirmation ? true : false;

    this.model.account = this._configService.getBrokerAccountSelected();
    if (this.data && this.data.symbol) {
      this.hiddenHeaderFull = configCookieBillet && configCookieBillet.billetRootShowHeaderFull ? true : false;
      this.model.quote = this.data.symbol;
      this.subscribeQuote(this.data.symbol);
    } else {
      this.hiddenHeaderFull = false;
      this.loading = false;
    }

    this.saveConfigCard(this.getBilletKey(), this.billetSelected.id, this.hiddenHeaderFull, this.hiddenConfirmationBillet);
    this._subscriptionAuthHbLogged = this._configService.authHbLogged$.subscribe((loggedNegotiation) => {
      this.getStrategies();
      if (loggedNegotiation || this.newWindow) {
        this.isLoggedNegotiation = true;
        this.getAccount();
      } else {
        this.isLoggedNegotiation = false;
        this.unsubscribeSocket();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribeSocket();
    this.unsubscribeQuote();
    this.unSubscriptionOms();
    if (this.isLoggedNegotiation) {
      this.unSubscribeDailyorder();
      this.unsubscribeScktPosition();
    }
    if (this._subscriptionAuthHbLogged) {
      this._subscriptionAuthHbLogged.unsubscribe();
    }
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
    if (this.subscriptionSendOrder) {
      this.subscriptionSendOrder.unsubscribe();
    }
  }

  resetOrderAfterSend() { 
    this.model.type = this.typeOrderSelected.webFeeder;
    this.model.orderStrategy = OrderEstrategyTypeEnum.DAYTRADE;
    this.model.timeInForce = TimeInForceEnum.DAY;
    this.model.validityOrder = new Date();
    this.model.stoptrigger = 0;
    this.model.stoplimit = 0;
    this.model.targettrigger = 0;
    this.model.targetlimit = 0;
    this.model.minimumIncrement = '0.01'; 
  }

  setInitValueBillet() {
    this.model.qtd = 0;
    this.model.orderStrategy = OrderEstrategyTypeEnum.DAYTRADE;
    this.model.timeInForce = TimeInForceEnum.DAY;
    this.model.side = SideEnum.BUY;
    this.model.type = this.typeOrderSelected.webFeeder;
    this.model.validityOrder = new Date();
    this.model.stoptrigger = 0;
    this.model.stoplimit = 0;
    this.model.targettrigger = 0;
    this.model.targetlimit = 0;
    this.model.minimumIncrement = '0.01';
    this.model.priceTickSize = this.tickSize;
    setTimeout(() => {
      this.getFinancialAccount(this.model.account);
    }, 500);
    if (this._configService.getHbSignature()) {
      this.model.signature = this._configService.getHbSignature();
    }
  }

  selectAsset(event) {
    if (event) {
      if (this.data) {
        this.data.symbol = event.symbol;
      }
      this.reset();
      if (event.symbol === '') {
        if (this.oldSymbolTemp !== undefined) {
          super.updateOnDemand(this.data.symbol, event.symbol);
        }
        this.oldSymbolTemp = undefined;
        this.model.quote = '';
      }
      this.subscribeQuote(event.symbol);
    }
  }

  unsubscribeQuote() {
    if (this._quoteService) {
      this._quoteService.unsubscribeQuote(this.model.quote, this.componentName);
    }
    if (this._subscriptionQuote) {
      this._subscriptionQuote.unsubscribe();
    }
  }

  subscribeQuote(symbol: string) {
    if (symbol) {
      symbol = AppUtils.trimStart(symbol);
      const oldSymbol = this.model.quote ? this.model.quote : '';
      this.oldSymbolTemp = oldSymbol;
      this.model.quote = symbol;
      if (this.oldSymbolTemp && this.model.quote && this.oldSymbolTemp.toLowerCase() === this.model.quote.toLowerCase() && this._subscriptionQuote) {
        return;
      }
      if (this.model.quote.toLowerCase() === 'invalid' || symbol === '') {
        this.hiddenInvalid = false;
        this.reset();
        this.model.quote = '';
        return;
      }
      this.initialPrice = true;
      const msgItem = this._quoteService.subscribeQuote(this.model.quote, this.componentName);
      if (msgItem !== undefined && msgItem !== '') {
        this.reset();
        return;
      }
      this.unsubscribeScktPosition(true);
      this.isSubscribeBook = false;
      this.isUpdateOnDemand = false;
      this.loadingImgName = true;
      this._subscriptionQuote = this._quoteService.messagesQuote.subscribe((msg: MessageQuote) => {
        if (msg && msg.errorMessage && this.model.quote && msg.symbol.toLowerCase() === this.model.quote.toLowerCase()) {
          this.hiddenInvalid = true;
          this.model.quote = null;
          this.company = null;
          this.model.company = null;
          this.model.imgName = '';
          this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), this.componentName);
          this.loading = false;
          this.reset();
        } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.model.quote) {
          this.messageQuote = msg;
          this.model.quotationForm = AppUtils.convertNumberAux(msg.quotationForm);
          this.model.contractMultiplier = AppUtils.convertNumberAux(msg.contractMultiplier);

          if (this.loadingImgName) {
            this.model.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(msg.symbol, msg.marketType).toUpperCase() + '.PNG';
            this.loadingImgName = false;
          }
          if (!this.isUpdateOnDemand) {
            this.isUpdateOnDemand = true;
            if (!this.newWindow) {
              super.updateOnDemand(this.oldSymbolTemp, this.model.quote);
            }
          }
          if (!this.isSubscribeBook) {
            setTimeout(() => {
              this.isSubscribeBook = true;
            }, 1000);
            if (this.model.account && this.subscriptionPositionList.length === 0 && this.messageQuote.marketType) {
              this.subscribeScktPosition();
            }
          }
          this.hiddenInvalid = false;
          this.model.loteDefault = this.messageQuote.loteDefault ? this.messageQuote.loteDefault : 100;
          this.model.indiceFuture = this.messageQuote.symbol.indexOf('win') === 0 || this.messageQuote.symbol.indexOf('dol') === 0 || msg.symbol.toLowerCase().indexOf('ind') === 0 ? true : false;
          this.tickSize = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 : this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
          this.model.priceTickSize = this.tickSize;
          this.model.minimumIncrement = this.messageQuote.minimumIncrement ? this.messageQuote.minimumIncrement.toString().replace(',', '.') : '0.01';
          this.variation = this.messageQuote.variation ? this.messageQuote.variation : '-';
          this.coinVariation = this.messageQuote.coinVariation && this.messageQuote.coinVariation.toString() !== '-' ? Number(this.messageQuote.coinVariation.toString().replace(',', '.')) : 0.0;
          if (this.messageQuote.description && this.messageQuote.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
            this.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
          } else {
            this.company = this.messageQuote.description;
          }
          this.model.company = this.company;
          this.model.market = this.messageQuote.marketType;
          if (this.initialPrice) {
            let priceTemp: any;
            if (this.data && this.data.price) {
              priceTemp = this.data.price;
              this.data.price = null;
            } else {
              priceTemp = this.messageQuote.lastTrade && this.messageQuote.lastTrade.toString() !== '0,00' && this.messageQuote.lastTrade.toString() !== '0' ? this.messageQuote.lastTrade : this.messageQuote.previous;
            }
            this.model.price = AppUtils.convertNumber(priceTemp);
            this.model.price = AppUtils.convertToNumber(this.model.price.toString(), this.messageQuote.tickSize);
            this.price = AppUtils.convertNumberToCurrency(priceTemp, this.tickSize);
            this.lastTrade = this.price;
            this.initialPrice = false;
            this.model.qtd = this.model.loteDefault > 0 ? this.model.loteDefault : 0;
          } else {
            if (this.messageQuote.lastTrade && this.messageQuote.lastTrade.toString() !== '-' && this.messageQuote.lastTrade.toString() !== '0,00' && this.messageQuote.lastTrade.toString() !== '0') {
              const lastTradeNumber = AppUtils.convertNumber(this.messageQuote.lastTrade.toString().replace('.', ''));
              this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), this.tickSize);
              this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, this.tickSize);
            } else {
              if (this.messageQuote.lastTrade && (this.messageQuote.lastTrade.toString() === '-' || this.messageQuote.lastTrade.toString() === '0,00' || Number(this.messageQuote.lastTrade) <= 0)) {
                const lastTradeNumber = AppUtils.convertNumber(this.messageQuote.previous.toString().replace('.', ''));
                this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), this.tickSize);
                this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, this.tickSize);
              } else {
                this.lastTrade = 0;
                this.model.price = this.lastTrade;
              }
              this.price = AppUtils.convertNumberToCurrency(this.lastTrade, this.tickSize);
            }
          }
          if (this.messageQuote.dateLastNegotiation) {
            const today = this._datePipe.transform(new Date(), 'dd/MM/yyyy');
            this.showVariation = today === this.messageQuote.dateLastNegotiation ? true : false;
          } else {
            this.showVariation = true;
          }
          if (this.messageQuote.theoryPrice && (this.messageQuote.theoryPrice > 0 || (this.messageQuote.theoryPrice.toString() !== '-' && Number(this.messageQuote.theoryPrice.toString().replace(',', '.'))))) {
            this.priceTheory = AppUtils.convertBrCurrencyToNumber(this.messageQuote.theoryPrice.toString(), ',');
            this.model.auctionHammer = true;
            const cardResize = { id: this.data.id, type: this.data.type };
            this._onResizeService._resizeCardBilletWks.next(cardResize);
            this.timeToOpen = this.messageQuote.timeToOpen;
            let previousConst = 0;
            if (this.messageQuote.previous && this.messageQuote.previous.toString() !== '-') {
              previousConst = AppUtils.convertBrCurrencyToNumber(this.messageQuote.previous.toString(), ',');
            }
            if (this.priceTheory > 0 && previousConst > 0) {
              let varTheoryTemp = (this.priceTheory / previousConst - 1) * 100;
              if (varTheoryTemp !== 0) {
                varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
              }
            }
          } else {
            this.priceTheory = 0;
            this.varTheory = null;
            this.timeToOpen = null;
            if (this.model.auctionHammer) {
              const cardResize = { id: this.data.id, type: this.data.type };
              this._onResizeService._resizeCardBilletWks.next(cardResize);
            }
            this.model.auctionHammer = false;
          }
        }
        this.valueInitBookStaircase.symbol = this.messageQuote.symbol;
        this.valueInitBookStaircase.minimumIncrement = this.messageQuote.minimumIncrement;
        this.valueInitBookStaircase.high = this.messageQuote.high;
        this.valueInitBookStaircase.low = this.messageQuote.low;
        this.valueInitBookStaircase.open = this.messageQuote.open;
        this.valueInitBookStaircase.marketType = this.messageQuote.marketType;
        this.valueInitBookStaircase.lastTrade = this.messageQuote.lastTrade;
        this.valueInitBookStaircase.previous = this.messageQuote.previous;
        if (this.loading) {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      });
    }
  }

  reset() {
    if (!this.model.quote) {
      return;
    }
    const oldSymbol = this.model.quote;
    if (this.data && oldSymbol && oldSymbol.toLowerCase() === this.data.symbol.toLowerCase()) {
      return;
    }
    // else if (this.data && super.validateOnlyOneAssetAssigned(this.data.symbol, this.data.type, this.data.workspaceId) === true) {
    //   this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG015, Constants.ALERT_TYPE.error);
    //   this.model.quote = '';
    //   super.updateOnDemand(oldSymbol, this.model.quote, true);
    //   setTimeout(() => {
    //     this.model.quote = oldSymbol;
    //   }, 0);
    //   return;
    // }
    this.unsubscribeQuote();
    this.unsubscribeScktPosition(true);
    this.listPosition = new BovBmfModel();
    this.company = '';
    this.model.imgName = '';
    this.model.minqtd = 0;
    this.model.price = 0;
    this.model.qtd = 0;
    this.price = null;
    this.lastTrade = null;
    this.variation = null;
    this.messageQuote = new MessageQuote();
    this.averagePricePos = null;
    this.model.minimumIncrement = '0.01';
    this.model.orderStrategy = this.orderStrategy;
  }

  getStrategies() {
    this.loadingStrategies = true;
    this._authServer.iNegotiation.getStrategies().subscribe(
      (res) => {
        this.strategiesList = res;
        if (this.strategiesList && this.strategiesList.length >= 2) {
          const defaultStrategy = this.strategiesList.findIndex((strategy) => strategy.orderStrategy == this.whiteLabel.billet.orderStrategy);
          this.orderStrategy = defaultStrategy !== -1 ? this.strategiesList[defaultStrategy].orderStrategy : null;
          this.model.orderStrategy = this.orderStrategy;
        }
        this.loadingStrategies = false;
      },
      () => {
        this.loadingStrategies = false;
      },
    );
  }

  getAccount() {
    this.intervalAccount = setInterval(() => {
      this.model.account = this._configService.getBrokerAccountSelected();
      if (this.model.account) {
        clearInterval(this.intervalAccount);
        if (this.model.account && this.subscriptionPositionList.length === 0 && this.messageQuote.marketType && (this.billetSelected.showBoxPosition || this.billetSelected.subscribeScktPosition)) {
          this.subscribeScktPosition();
          if (this.billetSelected.subscribeScktDailyOrder) {
            this.subscribeDailyorder();
          }
          this.getFinancialAccount(this.model.account);
        }
      } else {
        this.isLoggedNegotiation = false;
        this.unsubscribeSocket();
      }
    }, 1000);
  }

  changeAccount(account: string) {
    if (account) {
      this.unsubscribeScktPosition(true);
      this.unSubscribeDailyorder();
      this.financialAccount = {};
      this.model.account = account;
      this.getFinancialAccount(this.model.account);
      this._configService.writeLog(this.componentName + ' > changeAccount: ' + this.model.account);
      setTimeout(() => {
        if (this.billetSelected.subscribeScktDailyOrder) {
          this.subscribeDailyorder();
        }
        if (this.billetSelected.showBoxPosition || this.billetSelected.subscribeScktPosition) {
          this.subscribeScktPosition();
        }
      }, 1000);
    }
  }

  subscriptionOms() {
    this.subscriptionStatusOms = this._statusOmsService.messagesStatusOms.subscribe((statusOms) => {
      if (statusOms && statusOms === StatusConnection.ERROR) {
        this.statusOmsOnline = false;
        this._notificationService.warn('', this.msgStatusOmsOffile);
        setTimeout(() => {
          if (this.cdRef) {
            this.cdRef.detectChanges();
          }
        }, 500);
      } else {
        this.statusOmsOnline = true;
        setTimeout(() => {
          if (this.cdRef) {
            this.cdRef.detectChanges();
          }
        }, 500);
      }
    });
  }

  unSubscriptionOms() {
    if (this.subscriptionStatusOms) {
      this.subscriptionStatusOms.unsubscribe();
    }
  }

  subscribeScktPosition() {
    this.subscriptionPositionList.push(
      this._positionService.subscribePosition(this.model.account, this.componentName).subscribe((data) => {
        if (data) {
          Object.keys(data).forEach((element) => {
            const positionToUpdate = data[element].find((position: any) => (position.marketCode === MarketTypeEnum.BOVESPA && this.model.quote.substring(this.model.quote.length - 1).toUpperCase() === 'F' ? this.model.quote.substring(0, this.model.quote.length - 1).toUpperCase() === position.quote.toUpperCase() : this.model.quote.toUpperCase() === position.quote.toUpperCase()));
            if (positionToUpdate) {
              this.updatePositionQuote(positionToUpdate);
            }
          });
        }
      }),
    );
    this.subscriptionPositionList.push(
      this._positionService.messagesPosition.subscribe((data) => {
        const positionToUpdate = data.find((position: any) => (position.marketCode === MarketTypeEnum.BOVESPA && this.model.quote.substring(this.model.quote.length - 1).toUpperCase() === 'F' ? this.model.quote.substring(0, this.model.quote.length - 1).toUpperCase() === position.quote.toUpperCase() : this.model.quote.toUpperCase() === position.quote.toUpperCase()));
        if (positionToUpdate) {
          this.updatePositionQuote(positionToUpdate);
        }
      }),
    );
  }

  getFinancialAccount(account: any) {
    if (account) {
      this.financialAccount = {};
      this._authServer.iNegotiation.financialAccountInformationCompl(this.model.account, Constants.MARKET_BOVESPA).subscribe(
        (res: any) => {
          if (res && res.length > 0) {
            res.forEach((element) => {
              this.financialAccount.balanceProjOnline = element.balanceProjOnline.value ? Number(element.balanceProjOnline.value) : '-';
              this.financialAccount.uniqueLimit = element.uniqueLimit.value ? Number(element.uniqueLimit.value) : '-';
            });
          }
          setTimeout(() => {
            this.loading = false;
          }, 500);
        },
        () => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        },
      );
    }
  }

  updatePositionQuote(position) {
    if (!position) {
      return;
    }
    this.averagePricePos = position.averagePricePos ? this._dailyOrderService.removeSuffixPriceNumber(position.averagePricePos, position.marketCode) : 0;
    this.listPosition = position;
  }

  unsubscribeScktPosition(forceUnsubscribe?: boolean) {
    if (this._positionService && this.model.account) {
      this._positionService.unsubscribePosition(this.model.account, this.componentName, forceUnsubscribe);
      this.subscriptionPositionList.forEach((subscription) => subscription.unsubscribe());
      this.subscriptionPositionList = [];
      this.listPosition = new BovBmfModel();
    }
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
  }

  unsubscribeSocket() {
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
    this.unSubscriptionOms();
  }

  close() {
    if (this.showConfirmationBillet) {
      this.showConfirmationBillet = false;
      this.model.closeConfirmation = true;
    } else {
      this.removeItemFromWorkspace();
    }
  }

  changeBillet(value) {
    if (value && this.billetSelected.id !== value.id) {
      this.billetSelected = value;
      this.model.side = SideEnum.BUY;
      if (this.model.account) {
        if (this.billetSelected.subscribeScktDailyOrder) {
          this.subscribeDailyorder();
        }
        if (this.billetSelected.showBoxPosition || this.billetSelected.subscribeScktPosition) {
          this.subscribeScktPosition();
        }
      } else {
        if (!this.billetSelected.showBoxPosition || !this.billetSelected.subscribeScktPosition) {
          this.unsubscribeScktPosition();
        }
        if (!this.billetSelected.subscribeScktDailyOrder) {
          this.unSubscribeDailyorder();
        }
      }
      this.data.data.filter = value.name;
      this.saveConfigCard(this.getBilletKey(), this.billetSelected.id, this.hiddenHeaderFull, this.hiddenConfirmationBillet);
    }
  }

  getBilletKey() {
    let key = `${this.data.type}_${this.data.id}`;
    return key;
  }

  closeModalConfirm(value) {
    this.showConfirmationBillet = value;
    if (environment.RESET_BILLET_CONFIRMED_ORDER) {
      this.model.qtd = 0;
      this.model.closeConfirmation = true;
    }
  }

  openModalConfirm(value) {
    if (!this.hiddenConfirmationBillet) { 
      this.showConfirmationBillet = true;
      this.model = value;
    } else {
      this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, value);
    }
  }

  showHiddenConfirmationBilliet() {
    this.hiddenConfirmationBillet = !this.hiddenConfirmationBillet;
    this.saveConfigCard(this.data.type, this.billetSelected.id, this.hiddenHeaderFull, this.hiddenConfirmationBillet);
  }

  stopPropagation() {
    event.stopPropagation();
  }

  showHiddenHeader() {
    this.hiddenHeaderFull = !this.hiddenHeaderFull;
    this.saveConfigCard(this.data.type, this.billetSelected.id, this.hiddenHeaderFull, this.hiddenConfirmationBillet);
  }

  saveConfigCard(componentName: string, billetTypeId: number, billetShowHeaderFull: boolean, billetRootHiddenConfirmation: boolean) {
    const configCards: ConfigCardsModel = {
      billetRootTypeId: billetTypeId,
      billetRootHiddenConfirmation: billetRootHiddenConfirmation,
      billetRootShowHeaderFull: billetShowHeaderFull,
    };
    this._configService.setCookieConfigCards(componentName, configCards);
  }

  subscribeDailyorder() {
    this.subscribeScktDailyorder = true;
  }

  unSubscribeDailyorder() {
    if (this.subscribeScktDailyorder) {
      this.subscribeScktDailyorder = false;
    }
  }
}
